import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useAccountCache } from './cache'
import { type AccountRemoveInput, type AccountRemoveSuccess, Logger, toResponseError } from '@terros/common'

const logger = new Logger('useAccounts')

export function useRemoveAccount(): RemoveHookResponse<AccountRemoveInput> {
  logger.verbose('calling useRemoveAccount')
  const mutation = useTantalimMutation<AccountRemoveInput, AccountRemoveSuccess>({
    url: '/account/remove',
  })
  const { removeItem } = useAccountCache()

  async function remove(input: AccountRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      removeItem(input.accountId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
